'use client';
import React, { FC } from 'react';

import { TypeFullVideoSectionFields } from '@/core/generated-types/TypeFullVideoSection';
import { isMuxVideo } from '@/components/common/LandingPageHero/utils';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import MuxVideoSection from './components/MuxVideoSection';
import VideoSection from './components/VideoSection';

export const FullVideoSection: FC<TypeFullVideoSectionFields> = (props) => {
  const isDesktop = useIsDesktop();
  const media = isDesktop ? props.mediaDesktop : props.mediaMobile;
  const isMuxMedia = media && isMuxVideo(media);

  return (
    <>
      {isMuxMedia ? (
        <MuxVideoSection {...props} />
      ) : (
        <VideoSection {...props} />
      )}
    </>
  );
};

export default FullVideoSection;
